import React from 'react';
import './About.css';
// Import team member images
import stephenImage from '../assets/Stephen.jpg';
import ojImage from '../assets/OJ.jpg';
import deeImage from '../assets/Dee.jpg';
import meatballImage from '../assets/meatball.jpg';

const About = () => {
  return (
    <div className="about">
      <div className="about-header">
        <h1>About Black Cat Paranormal</h1>
        <p>Professional paranormal investigators with over a decade of experience</p>
      </div>

      <div className="about-section">
        <h2>Our Story</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              Founded in 2025, Black Cat Paranormal team was formed by Stephen, a passionate paranormal enthusiast with a mission to investigate and document paranormal activity using scientific methods and cutting-edge technology.
            </p>
            <p>
              What started as a personal interest quickly evolved into a professional operation as our reputation grew. We investigate locations across the country, from historic landmarks to private residences, always with the utmost respect for both the living and the spirits we encounter.
            </p>
            <p>
              Our name, "Black Cat," was chosen to embrace the superstitions and folklore that often surround paranormal investigations. Just as black cats have been both feared and revered throughout history, we approach the unknown with both caution and fascination.
            </p>
          </div>
          <div className="about-image">
            {/* Image placeholder - will be replaced with actual image */}
            <div className="image-placeholder">Team Image</div>
          </div>
        </div>
      </div>

      <div className="about-section dark-section">
        <h2>Meet Our Team</h2>
        <div className="team-container">
          <div className="team-member">
            <div className="member-image">
              <img src={stephenImage} alt="Stephen - Founder" />
            </div>
            <h3>Stephen</h3>
            <p className="member-title">Founder</p>
            <p>Stephen has had a lifelong passion for the paranormal. His methodical approach and deep respect for spirits guide the team's investigations.</p>
          </div>
          <div className="team-member">
            <div className="member-image">
              <img src={ojImage} alt="OJ - Investigator" />
            </div>
            <h3>OJ</h3>
            <p className="member-title">Investigator</p>
            <p>Always down for an adventure, OJ brings enthusiasm and energy to every investigation. His fearless approach makes him invaluable when exploring the unknown.</p>
          </div>
          <div className="team-member">
            <div className="member-image">
              <img src={deeImage} alt="Dee - Skeptic Investigator" />
            </div>
            <h3>Dee</h3>
            <p className="member-title">Skeptic Investigator</p>
            <p>As the team's resident skeptic, Dee approaches each investigation with a critical eye. His analytical mindset helps ensure all natural explanations are considered before drawing paranormal conclusions.</p>
          </div>
          <div className="team-member">
            <div className="member-image">
              <img src={meatballImage} alt="Meatball - The Black Cat" />
            </div>
            <h3>Meatball</h3>
            <p className="member-title">The Black Cat</p>
            <p>The inspiration behind our name. Meatball's mysterious nature and uncanny ability to sense the paranormal sparked the creation of Black Cat Paranormal.</p>
          </div>
        </div>
      </div>

      <div className="about-section">
        <h2>Our Equipment</h2>
        <div className="equipment-container">
          <div className="equipment-category">
            <h3>Audio Equipment</h3>
            <ul>
              <li>Digital Voice Recorders</li>
              <li>Parabolic Microphones</li>
              <li>Spirit Boxes</li>
              <li>Ultrasonic Detectors</li>
            </ul>
          </div>
          <div className="equipment-category">
            <h3>Visual Equipment</h3>
            <ul>
              <li>Full Spectrum Cameras</li>
              <li>Infrared Cameras</li>
              <li>Night Vision Cameras</li>
              <li>Motion Sensors</li>
            </ul>
          </div>
          <div className="equipment-category">
            <h3>Environmental Monitoring</h3>
            <ul>
              <li>EMF Meters</li>
              <li>Temperature Gauges</li>
              <li>Barometric Pressure Sensors</li>
              <li>Geiger Counters</li>
            </ul>
          </div>
          <div className="equipment-category">
            <h3>Communication Tools</h3>
            <ul>
              <li>Ovilus Devices</li>
              <li>REM Pods</li>
              <li>Dowsing Rods</li>
              <li>Pendulums</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="about-section dark-section">
        <h2>Our Approach</h2>
        <div className="approach-container">
          <div className="approach-step">
            <div className="step-number">1</div>
            <h3>Research</h3>
            <p>We thoroughly research the history of each location before investigation, including past reports of paranormal activity.</p>
          </div>
          <div className="approach-step">
            <div className="step-number">2</div>
            <h3>Investigation</h3>
            <p>Using scientific methods and equipment, we conduct thorough investigations to capture evidence of paranormal activity.</p>
          </div>
          <div className="approach-step">
            <div className="step-number">3</div>
            <h3>Analysis</h3>
            <p>All evidence is carefully analyzed to rule out natural explanations before considering paranormal causes.</p>
          </div>
          <div className="approach-step">
            <div className="step-number">4</div>
            <h3>Documentation</h3>
            <p>We provide detailed reports of our findings, including all evidence captured during the investigation.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
